import React from 'react';
import { Link } from 'gatsby';
import CDNImage from "../../common/cdn-image";

const giftCardsBlock = (
	<div className="detail-block">
		<div className="icon">
			<CDNImage
				imagePath="/interface/gift-card.png"
				width="128"
				height="128"
			/>
		</div>
		<div className="text">
			<p className="body large">
				Buying a gift and not sure what your recipient would like? Let
				them choose with <Link to="/shop/gift-cards/">our gift card</Link>.
			</p>
		</div>
	</div>
);

const wholesaleBlock = (
	<div className="detail-block">
		<div className="icon">
			<CDNImage
				imagePath="/interface/wholesale.png"
				width="128"
				height="128"
			/>
		</div>
		<div className="text">
			<p className="body large">
				Interested in wholesale? Contact <a href="mailto:shop@publicdomainreview.org">shop@publicdomainreview.org</a>{' '}
				for more info.
			</p>
		</div>
	</div>
);

const PrintsSpecialServicesBanner = () => {
	return (
		<div className="prints-shop-banner">
			<div className="prints-shop-banner-cell">
				{giftCardsBlock}
			</div>
			<div className="prints-shop-banner-cell">
				{wholesaleBlock}
			</div>
		</div>
	);
};

export default PrintsSpecialServicesBanner;